var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBscTestnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BNB Chain Goerli"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.79281 16.0007L8.80435 20.2314L12.3992 22.3468V24.8237L6.7005 21.4814V14.7635L8.79281 16.0007ZM8.79281 11.7699V14.2353L6.69922 12.9968V10.5314L8.79281 9.29297L10.8967 10.5314L8.79281 11.7699ZM13.9005 10.5314L15.9941 9.29297L18.0979 10.5314L15.9941 11.7699L13.9005 10.5314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3047 19.3545V16.8776L12.3983 18.116V20.5814L10.3047 19.3545ZM13.8996 23.234L15.9931 24.4725L18.097 23.234V25.6994L15.9931 26.9378L13.8996 25.6994V23.234ZM21.0996 10.5314L23.1931 9.29297L25.297 10.5314V12.9968L23.1931 14.2353V11.7699L21.0996 10.5314ZM23.1931 20.2314L23.2047 16.0007L25.2983 14.7622V21.4801L19.5996 24.8225V22.3455L23.1931 20.2314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.6932 19.3539L19.5996 20.5808V18.1154L21.6932 16.877V19.3539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.6919 12.6458L21.7034 15.1228L18.0983 17.2381V21.4792L16.0047 22.7061L13.9111 21.4792V17.2381L10.306 15.1228V12.6458L12.4085 11.4074L15.9919 13.533L19.597 11.4074L21.7008 12.6458H21.6919ZM10.3047 8.41635L15.9931 5.0625L21.6919 8.41635L19.5983 9.65481L15.9931 7.52917L12.3983 9.65481L10.3047 8.41635Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscTestnet);
export default __webpack_public_path__ + "static/media/bsc-testnet.133811f18dfe25e5f0a0e74835d7e0e9.svg";
export { ForwardRef as ReactComponent };